module.exports = __webpack_public_path__ + "static/media/download.f0cf3960.png";